import INApi from './_inApi.js';
import httpClient from '@/apis/base/httpclient';

class INAdjustmentAPI extends INApi {
  constructor() {
    super();
  }
  controllerName = 'INAdjustments';

  /**
   * Lấy gía trị tồn kho +Sl tồn kho theo mã kho
   * NNKiem 24.07.2022
   */
  GetQuanlityAndAmountInventoryByStock(payload) {
    let request = {
      url: this.getAPIUrl() + '/GetQuanlityAndAmountInventoryByStock',
      data: payload,
    };

    return httpClient.getAsync(request);
  }

  /**
   * Lấy gía trị tồn kho +Sl tồn kho
   * NNKiem 24.07.2022
   */
  GetQuanlityAndAmountInventory(payload) {
    let request = {
      url: this.getAPIUrl() + '/GetQuanlityAndAmountInventory',
      data: payload,
    };

    return httpClient.postAsync(request);
  }
}
export default new INAdjustmentAPI();
